// Dados dos eventos
export const eventos = [
  {
    id: 3,
    titulo: "Acampamento Carcará 2026",
    resumo:
      "Homens Fortes. Propósitos Maiores. Missão Eterna. Dois dias de comunhão, edificação e desafios, nos dias 21 e 22 de novembro.",
    imagem: "/images/acampamento_carcara_2026.jpeg",
    data: "21 e 22 de novembro de 2026",
    autor: "Ministério de Homens — Verbo da Vida",
    link: "/inscricoes",
    conteudo: `Homens Fortes. Propósitos Maiores. Missão Eterna.

O Acampamento Carcará 2026 é um chamado aos homens da Verbo da Vida para dois dias intensos de comunhão, edificação, desafios e propósito. Um tempo para fortalecer a fé, criar laços e ser desafiado a viver a missão que Deus preparou.

Data: 21 e 22 de novembro de 2026.

Pilares: Comunhão • Edificação • Desafios • Propósito.

Valor da Inscrição ----- R$ 75,00 

Aceitamos :
Dinheiro Presencial
Pix 
Cartão Crédito e Débito

Para se inscrever e tirar dúvidas, busque informações com a liderança.`,
  },
];

export default eventos;
